import script from "./editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./editor.vue?vue&type=script&setup=true&lang=ts"

import "./editor.vue?vue&type=style&index=0&id=1404c544&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1404c544"]])

export default __exports__